(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    // Variant image switching for media gallery
  document.addEventListener('DOMContentLoaded', function() {
    // Wait for media-gallery component to be ready
    setTimeout(function() {
      initVariantImageSwitching();
    }, 100);
    
    function initVariantImageSwitching() {
      // Find variant selectors (common patterns)
      const variantSelectors = [
        ...document.querySelectorAll('input[name="id"], select[name="id"]'),
        ...document.querySelectorAll('.product-form__input input[type="radio"]'),
        ...document.querySelectorAll('.product-form__input select'),
        ...document.querySelectorAll('[data-product-variant-select]')
      ];
      
      if (variantSelectors.length === 0) return;
      
      function updateGalleryForVariant(variantId) {
        if (!variantId) return;
        
        // Fetch variant data
        fetch('/variants/' + variantId + '.js')
          .then(response => response.json())
          .then(variant => {
            if (variant.featured_image && variant.featured_image.src) {
              // Find the main media-gallery component
              const mediaGallery = document.querySelector('media-gallery');
              if (!mediaGallery) return;
              
              // Method 1: Find slideshow component inside media-gallery
              const slideshow = mediaGallery.querySelector('slideshow-component');
              if (slideshow) {
                // Get all slides
                const slides = slideshow.querySelectorAll('slideshow-slide');
                let targetSlideIndex = -1;
                
                // Find slide matching variant image
                slides.forEach((slide, index) => {
                  const img = slide.querySelector('img');
                  if (img && img.src.includes(variant.featured_image.src.split('?')[0])) {
                    targetSlideIndex = index;
                  }
                });
                
                // If found, switch to that slide
                if (targetSlideIndex !== -1 && slideshow.goToSlide) {
                  slideshow.goToSlide(targetSlideIndex);
                } else if (targetSlideIndex !== -1) {
                  // Fallback: manually update
                  slides.forEach((slide, index) => {
                    slide.setAttribute('aria-hidden', index !== targetSlideIndex);
                  });
                }
              }
              
              // Method 2: Update thumbnails active state
              const thumbnails = mediaGallery.querySelectorAll('.dialog-thumbnails-list__thumbnail, .slideshow-controls__thumbnail');
              thumbnails.forEach((thumbnail, index) => {
                const thumbnailImg = thumbnail.querySelector('img');
                if (thumbnailImg && thumbnailImg.src.includes(variant.featured_image.src.split('?')[0])) {
                  thumbnail.setAttribute('aria-selected', 'true');
                  // Scroll thumbnail into view
                  thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                } else {
                  thumbnail.setAttribute('aria-selected', 'false');
                }
              });
            }
          })
          .catch(error => console.warn('Variant fetch error:', error));
      }
      
      // Listen for variant changes
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', function(e) {
          const variantId = this.value;
          updateGalleryForVariant(variantId);
        });
      });
      
      // Handle Shopify's built-in variant change events
      document.addEventListener('variant:changed', function(event) {
        if (event.detail && event.detail.variantId) {
          updateGalleryForVariant(event.detail.variantId);
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
